import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getKvartalVunnenProspektByAfid,setofUpdatedashboard} from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import Kvartal from "../Progress/Kvartal";
import {NumberFormat} from 'components/NotyNumberFormat'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboard,DashBoardValueOf} = accountsData;
    const { KvartalVunneProspekt,DashboardProspektFilterOption } = DashBoard;
    return {
        authUser,KvartalVunneProspekt,DashboardProspektFilterOption,
        updatedashboard,DashBoardValueOf
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getKvartalVunnenProspektByAfid:(Afid,userid,FilterOption) => dispatch(getKvartalVunnenProspektByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
        dispatch
    };
}
class ExtraLargePerMånad extends Component {
    state={
        KvartalVunneProspekt:{
            KvartalV:0,
            KvartaTBV:0,
            KvartalB:0,
        },
        DashboardProspektFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getKvartalVunnenProspektByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })        
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({ done:false })
                    const Afid = this.props.Afid;
                    this.props.getKvartalVunnenProspektByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            180000
        );
      }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    getDashBoardValueOf = ()=>{
        try{
        let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 2)
        if(ModuleValue.Value > 2 && ModuleValue.Value !== 5){
            return 2
        }else{
            return 1
        }
    }
    catch(error){return 1}
    }
    formatNumber1=(number)=>{
        const _ValueOF = this.getDashBoardValueOf()
        return NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 1)
    }
    formatNumber=(number)=>{
        try{
            const _ValueOF = this.getDashBoardValueOf()
            let Nubmer =  NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
            //let Nubmer = NumberFormat(number, 'compact', 'auto', 0)
            let suffix = Nubmer.match(/[a-zA-Z]+/g)
            let num = Nubmer.replace(suffix, '').trim()
						let fontSize = 100
						if(String(num).length > 5) fontSize = 70
						if(String(num).length > 7) fontSize = 50

            return (<span  style={{ fontSize, lineHeight: '1' }}>{num}<span style={{ fontSize: 30,marginLeft:5, lineHeight: '1' }}>
                            {this.formatNumberT(number)}
                        </span></span> )
        }
        catch(error){
            const _ValueOF = this.getDashBoardValueOf()

            return <span  style={{ fontSize: '100px' }}>{NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)}</span> 
        }
    }
    formatNumberT=(number)=>{
        try{
            const _ValueOF = this.getDashBoardValueOf()
            let Nubmer = NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
            let num = Nubmer.match(/[a-zA-Z]+/g)
            return num
        }
        catch(error){
            return ''
        }
    }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboard) === 1){
            this.props.getKvartalVunnenProspektByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             })
             this.props.setofUpdatedashboard()
        }
        if(this.props.DashboardProspektFilterOption !== this.state.DashboardProspektFilterOption && !isEmpty(this.props.DashboardProspektFilterOption))
        {
             
            
            this.props.getKvartalVunnenProspektByAfid(Afid,undefined,this.state.DashboardProspektFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
            this.setState({
                DashboardProspektFilterOption:this.props.DashboardProspektFilterOption 
            }) 
        }
        if(!isUndefined(this.props.KvartalVunneProspekt)){
            if(this.props.KvartalVunneProspekt !== this.state.KvartalVunneProspekt){
                this.setState({
                    KvartalVunneProspekt:this.props.KvartalVunneProspekt
                })
            }
        }
    }
    render() {
        return (
            <div>
                  {
                    this.state.done === false?
                    <Skeleton variant="rectangular"  height={ '100px'} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                    :
                    <div className="d-flex align-items-end" >
                        <p style={{ fontSize: 30,   }}></p>
												{this.formatNumber(this.state.KvartalVunneProspekt.KvartalV)}
										</div>
    				}
    {
                    this.state.done === false?
                    <Skeleton variant="rectangular"  height={ '30px'} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                    :
            <div className="text-left  d-flex justify-content-between">
                <p style={{ fontSize: 20, margin:'0', color: '#44D1C2' }}><IntlMessages id="input.options.Quarter"/></p>
                {
                    parseInt(this.props.authUser.user_canSeeTB1)===1?
                    <p style={{ fontSize: 20, margin:'0', color: '#44D1C2' }}> {this.formatNumber1(this.state.KvartalVunneProspekt.KvartaTBV)}{this.formatNumberT(this.state.KvartalVunneProspekt.KvartaTBV)}</p>
                    :""
                } 
            </div>
    }
     {
                    this.state.done === false?
                    <Skeleton variant="rectangular"  height={ '10px'} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                    :
            <div style={{marginTop:'1rem'}}>
                <Kvartal 
                KvartalVunneProspekt={this.state.KvartalVunneProspekt}
                />
            </div>
    }
     {
                    this.state.done === false?
                    <Skeleton variant="rectangular"  height={ '20px'} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                    :
            <div className="d-flex row">
                <div className="col-6">
                    <p style={{fontSize:16}} className="text-left">
                        {`${
                            parseInt(this.state.KvartalVunneProspekt.monthV)===0?
                            0:
                            (parseInt(this.state.KvartalVunneProspekt.KvartalV)/(parseInt(this.state.KvartalVunneProspekt.KvartalB)===0?10000:this.state.KvartalVunneProspekt.KvartalB)*100).toFixed(0)
                        }`}%
                    </p>
                </div>
                <div className="col-6">
                    <p style={{fontSize:16}} className="text-right">
                        {
                            parseInt(this.state.KvartalVunneProspekt.KvartalB)===0?
                            `${this.formatNumber1(10000)}`:
                            `${this.formatNumber1(this.state.KvartalVunneProspekt.KvartalB)}`
                        }
                    </p>
                </div>

            </div>
    }
        </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(ExtraLargePerMånad);



